import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/overview",
)({
  staticData: { title: "Overview" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/overview/overview.tsx"),
    "Overview",
  ),
})
